import {Button, Modal} from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { reqPostExposureSummary } from "../../../../api";
import utils from '../../../../utils/utils'
const UpgradePlanModal = ({upgradeOpen,setUpgradeOpen}) => {
    const router  = useHistory()
    // 弹窗点击人数
    const handlePageStatistics = async(type) => {
        try {
            const params = { type: type };
            await reqPostExposureSummary(params);
             // 关闭弹窗
             setUpgradeOpen();
             // 跳转到pricing页面
             utils.routeListen('/admin/subscribe')
            utils.routeJump1(router,'/admin/subscribe')
        } catch (error) {}
    }
   
    // const data = {
    //     list1: [
    //         {
    //             title:'$5 off $10 Coupon x 5',
    //             strong:true
    //         },
    //         {
    //             title:'25 Sourcing Requests per Day',
    //             strong:false
    //         },
    //         {
    //             title:'Access to 1M+ Products',
    //             strong:false
    //         },
    //         {
    //             title:'24/7 Live Chat',
    //             strong:false
    //         },
    //         {
    //             title:'Unlimited AliExpress Product Import',
    //             strong:false
    //         },
    //         {
    //             title:'Unlimited Orders Fulfillment',
    //             strong:false
    //         },
    //         {
    //             title:'Order Auto Sourcing',
    //             strong:false
    //         },
    //         {
    //             title:'Unlimited DSM Product Import',
    //             strong:false
    //         },
    //         {
    //             title:'Custom Branding',
    //             strong:false
    //         },
    //     ],
    //     list2: [
    //         {
    //             title:'Dedicated Manager',
    //             strong:true
    //         },
    //         {
    //             title:'Bulk Product Sourcing',
    //             strong:false
    //         },
    //         {
    //             title:'Automated Fulfillment',
    //             strong:false
    //         },
    //         {
    //             title:'Private Storage',
    //             strong:false
    //         },
    //         {
    //             title:'Private Product Listing',
    //             strong:false
    //         },
    //         {
    //             title:'Order Tracking',
    //             strong:false
    //         },
    //         {
    //             title:'Trending Products',
    //             strong:false
    //         },
    //         {
    //             title:'Automated Product Pricing',
    //             strong:false
    //         },
    //         {
    //             title:'Remove China Label',
    //             strong:false
    //         },
            
    //     ],
    // }
    
  return (
    <div className="discount_upgrade_modal">
      <Modal
        open={upgradeOpen}
        onClose={() => setUpgradeOpen()}
      >
        <Modal.Section>
       <div className="plan_grade_content">
       <div className="plan_upgrade_head">
       <img style={{verticalAlign:'bottom'}} src="/emojis_hua.png" alt="dropshipman"/>
           <p>Upgrade to new plan with <strong>18</strong> features and enjoy a <strong>20%</strong> discount</p>
       </div>
       {/* <span style={{borderBottom: "1px solid rgb(0 0 0 / 10%)",width:'100%',height:'100%',display:'block',marginTop:'10px'}}></span> */}
       {/* <div className="plan_upgrade_conetent">
       <div>
           <ul>
               {data.list1.map((item,ind)=><li key={ind} style={{fontWeight:item.strong && 700}}>{item.title}</li>)}
           </ul>
       </div>
       <div>
            <ul>
               {data.list2.map((item,ind)=><li key={ind} style={{fontWeight:item.strong && 700}}>{item.title}</li>)}
           </ul>
       </div>
       </div> */}
       <div className="plan_upgrade_conetent_button">
           <Button onClick={()=>handlePageStatistics('upgrade_button')}><img style={{verticalAlign:'bottom',marginRight:"6px"}} src="/emojis_plan.png" alt="dropshipman"/> <span style={{fontSize:'18px'}}> GET 20% DISCOUNT</span></Button>
       </div>
       <div className="plan_upgrade_conetent_des">
       Valid from Jun 7th to Jun 22nd , 2023
       </div>
       </div>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default UpgradePlanModal;
